import { c as _c } from "react/compiler-runtime";
import type { MedianIncomeYear } from '../constants';
import { MEDIAN_INCOME_BY_YEAR } from '../constants';
interface HeroProps {
  year: MedianIncomeYear;
}

/**
 * ① Hero — 페이지 상단의 정의 + 출처 배지. 정적 콘텐츠라 서버 컴포넌트.
 */
export const Hero = t0 => {
  const $ = _c(11);
  const {
    year
  } = t0;
  const bundle = MEDIAN_INCOME_BY_YEAR[year];
  let t1;
  if ($[0] !== year) {
    t1 = <h1 className="font-700 text-Gray-900 typo-h4 mobile-tablet:typo-h5">{year} 기준 중위소득 종합 가이드</h1>;
    $[0] = year;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="font-700 text-Gray-900 typo-body3">‘기준 중위소득’이란 무엇인가요?</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li><strong className="font-700 text-Gray-900">기준 중위소득</strong>은 전체 가구를 소득 순으로 줄세웠을 때 정확히 가운데(50번째) 가구의 소득입니다.</li>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li>보건복지부장관이 매년 7~8월경{" "}<strong className="font-700 text-Gray-900">중앙생활보장위원회 심의·의결</strong>을 거쳐 고시합니다.</li>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-8 rounded-small bg-Gray-50 p-16">{t2}<ol className="flex list-decimal flex-col gap-4 pl-20 text-Gray-700 typo-body4">{t3}{t4}<li>기초생활보장 4대 급여(생계·의료·주거·교육)를 비롯해{" "}<strong className="font-700 text-Gray-900">14개 부처 80여 개 복지사업</strong>의 수급자 선정기준으로 활용됩니다.</li></ol></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== bundle.source) {
    t6 = <span className="w-fit rounded-pill bg-Gray-100 px-12 py-4 text-Gray-700 typo-caption1">🏛 출처: {bundle.source}</span>;
    $[6] = bundle.source;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t1 || $[9] !== t6) {
    t7 = <section className="flex flex-col gap-16 mobile-tablet:px-16">{t1}{t5}{t6}</section>;
    $[8] = t1;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};